'use strict'
import {
  serialize
} from './index'
import AppError from './errors'
import ERRORS from '../constants/errors'
import router from '../router'
import PAGES from '../constants/page'
import 'whatwg-fetch'
import toast from '../components/toast'

export const verbs = {
  GET (url, params) {
    return fetch(params ? `${url}?${params}` : url, {
      credentials: 'same-origin'
    })
  },
  POST (url, params) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params
    })
  }
}

export const request = (url, method = 'GET', params = {}) => {
  console.log(url)
  return verbs[method](url, serialize(params))
    .then(res => {
      if (res.ok) {
        return res
      } else {
        throw new AppError(ERRORS.NETWORK_ERROR)
      }
    })
    .then((res) => res.json())
    .then((res) => {
      if (!res.success && (res.msg === '未登录' || res.msg === '用户已登出')) {
        console.log(router.currentRoute)

        toast.hide()
        router.replace({
          name: PAGES.LOGIN,
          query: {url: router.history.current.path}
        })
        throw new AppError(ERRORS.SESSION_EXPIRE)
      } else {
        return res
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/request.js